module.exports = __webpack_public_path__ + "media/header-mobile-ru.d1ffa1d3.mp4";